module.exports = __webpack_public_path__ + "img/MOVR.f6c5fc22.png";